import { useEffect, useState } from 'react';

import type { LiveShopping } from '../../../@types/LiveShopping';

const calc = (_result?: LiveShopping) => {
  if (!_result) return null;
  const result = { ..._result };
  const date = !!_result.scheduledStartAt && !_result.isArchived && !_result.isLive;
  if (date) {
    const currDate = new Date().valueOf();
    if (new Date(_result.scheduledStartAt).setMilliseconds(0).valueOf() < currDate) {
      result.isLive = true;
      result.state = 'live';
    }
  }
  return result;
};

const useResultUpdater = (_result?: LiveShopping) => {
  const [result, setResult] = useState(calc(_result));

  useEffect(() => {
    let timeout: NodeJS.Timeout;
    if (_result) {
      setResult(calc(_result));
      const date = !!_result.scheduledStartAt && !_result.isArchived && !_result.isLive;
      if (date) {
        timeout = setInterval(() => {
          const currDate = new Date().valueOf();

          if (new Date(_result.scheduledStartAt).setMilliseconds(0).valueOf() < currDate) {
            setResult({
              ..._result,
              isLive: true,

              state: 'live',
            });
            clearInterval(timeout);
          }
        }, 1000);
      }
    }

    return () => {
      clearInterval(timeout);
    };
  }, [_result]);

  return result;
};

export default useResultUpdater;
